package app.nestbridge.feature.invitations.presentation

import app.nestbridge.feature.invitations.screen.SendInvitationScreen
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.Navigator
import com.slack.circuit.runtime.presenter.Presenter
import com.slack.circuit.runtime.screen.Screen
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
@Origin(SendInvitationPresenter::class)
public class SendInvitationPresenterFactory(
  private val factory:
      (screen: SendInvitationScreen, navigator: Navigator) -> SendInvitationPresenter,
) : Presenter.Factory {
  override fun create(
    screen: Screen,
    navigator: Navigator,
    context: CircuitContext,
  ): Presenter<*>? = when (screen) {
    is SendInvitationScreen -> factory(screen, navigator)
    else -> null
  }
}
